export default "__VITE_ASSET__1510cae2__"